export default (ctx, inject) => {
  const registrationProgress = {
    get: async (part) => {
      const units = await ctx.store.dispatch('registration/getUnitsForOverview')

      // 01. how many units do we have to scan & are scanned
      // 02. commissioning date (not when we have code)
      // 03. building date (not when we have code)
      // 04. end user info
      // 05. end user & installation address
      // 06. service partner (not when we have code)
      // 07. summary
      const cases = [
        'scan-units',
        'commissioning',
        'building-house',
        'end-user-personal-info',
        'end-user-address',
        'service-partner'
      ]
      const step = 90 / (units.length + cases.length)
      let progress = 10

      switch (part) {
        case 'scan-units': {
          const scannedUnits = units.filter((u) => !!(u.material && u.serial))
          progress += step * scannedUnits.length
          break
        }
        default:
          progress += step * (units.length + cases.indexOf(part))
          break
      }

      return progress
    }
  }

  ctx.$registrationProgress = registrationProgress
  inject('registrationProgress', registrationProgress)
}
